import { cast, types } from 'mobx-state-tree'

export const editableModel = () =>
  types.model().actions((self) => ({
    setValue: (k, value) => (self[k] = cast(value)),
  }))
